import { createSlice } from '@reduxjs/toolkit';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    isWebp: false,
    loadImages: false,
    activePage: null,
    showCookieBanner: true,
  },
  reducers: {
    setWebp: (state, action) => {
      state.isWebp = action.payload;
      state.loadImages = true;
    },
    setActivePage: (state, action) => {
      state.activePage = action.payload;
    },
    setShowCookieBanner: (state, action) => {
      state.showCookieBanner = action.payload;
    },
  },
});

export const { setWebp, setActivePage, setShowCookieBanner } = uiSlice.actions;

export const selectWebp = (state) => state.ui.isWebp;
export const selectLoad = (state) => state.ui.loadImages;
export const selectActivePage = (state) => state.ui.activePage;
export const selectShowCookieBanner = (state) => state.ui.showCookieBanner;

export default uiSlice.reducer;
